// 新手引导 默认情况下有三种 对照组/实验组1/实验组2
const GuideTools = {
    state: {
        belongsGroup: null, // 所属组
        originalGroupId: null, // 原始所属组，不会变更
        lockGuideToolsBuried: false, // 目前仅在实验组1中第一步useEffect中使用，因guideTools中调用多次埋点，在这里上一个锁 false可以正常调用，true即为锁，
        controlGroupToolsTip: false, // 默认不显示， 实验组关闭的瞬间弹窗toolstips
        lockGuideControlToolsTipBuried: false,// 这次是对照组5埋点的锁
        isIndexLoading: true, // loading页
        // lockGuideFirstStepJump: false, //实验组1点击模型/风格的时候进行下一步跳转时的锁。注意是锁。 主要解决effect时会重复调用3次的问题。
    },
    reducers: {
        updateState(state, payload) {
            return {
                ...state,
                ...payload
            };
        },
    },
    effects: {
        // setLockGuideFirstStepJump(boolean) {
        //     console.log('setLockGuideFirstStepJump _ guideTools', boolean)
        //     this.updateState({
        //         lockGuideFirstStepJump: boolean
        //     });
        // },
        setIndexLoading(boolean) {
            this.updateState({isIndexLoading: boolean});
        },
        setControlsTip(boolean) {
            this.updateState({
                controlGroupToolsTip: boolean
            })
        },
        setLockBuriedControlGroup(locked) {
            this.updateState({
                lockGuideControlToolsTipBuried: locked
            })
        },
        setLockBuried(locked) {
            this.updateState({
                lockGuideToolsBuried: locked
            })
        },
        setGroup(belongsGroup) {
            this.updateState({
                belongsGroup
            })
        },
        setOriginalGroupId(groupId) {
            this.updateState({
                originalGroupId: groupId
            })
        }
    }
}

export default GuideTools